import { ConnectivityState, StorageType } from '../shared';
import type { Location } from './types';

export const STUB_LOCATIONS: Location[] = [
  {
    name: 'locations/11111111-1111-1111-1111-111111111111',
    uid: '11111111-1111-1111-1111-111111111111',
    displayName: 'HSBC Source Bucket',
    description: 'HSBC T3 source S3 bucket for invoice files',
    uri: 's3://c2foupload-fss/0001buyer01div/incoming/',
    credential: 'credentials/cred-aws-hsbc-prod',
    storageType: StorageType.STORAGE_TYPE_S3,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2024-01-10T08:00:00Z',
    updateTime: '2024-02-15T10:30:00Z',
  },
  {
    name: 'locations/22222222-2222-2222-2222-222222222222',
    uid: '22222222-2222-2222-2222-222222222222',
    displayName: 'HSBC Target SFTP',
    description: 'HSBC T3 target SFTP server for invoice delivery',
    uri: 'sftp://hsbc-sftp.example.com/inbound/',
    credential: 'credentials/cred-ssh-hsbc-sftp',
    storageType: StorageType.STORAGE_TYPE_SFTP,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2024-01-10T08:15:00Z',
    updateTime: '2024-02-15T10:30:00Z',
  },
  {
    name: 'locations/33333333-3333-3333-3333-333333333333',
    uid: '33333333-3333-3333-3333-333333333333',
    displayName: 'SMBC EMEA Source',
    description: 'SMBC EMEA feedback file source location',
    uri: 's3://smbc-emea-bucket/exports/',
    credential: 'credentials/cred-aws-smbc-emea',
    storageType: StorageType.STORAGE_TYPE_S3,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2024-01-15T09:00:00Z',
    updateTime: '2024-02-10T14:00:00Z',
  },
  {
    name: 'locations/44444444-4444-4444-4444-444444444444',
    uid: '44444444-4444-4444-4444-444444444444',
    displayName: 'SMBC EMEA Target',
    description: 'SMBC EMEA feedback file target location',
    uri: 'sftp://smbc-emea.example.com/imports/',
    credential: 'credentials/cred-ssh-smbc-emea',
    storageType: StorageType.STORAGE_TYPE_SFTP,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_UNTESTED,
    createTime: '2024-01-15T09:15:00Z',
    updateTime: '2024-02-10T14:00:00Z',
  },
  {
    name: 'locations/55555555-5555-5555-5555-555555555555',
    uid: '55555555-5555-5555-5555-555555555555',
    displayName: 'Truist Source GCS',
    description: 'Truist transaction data source on Google Cloud Storage',
    uri: 'gs://truist-data-bucket/transactions/',
    credential: 'credentials/cred-gcp-truist',
    storageType: StorageType.STORAGE_TYPE_GCS,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2023-11-01T12:00:00Z',
    updateTime: '2024-01-20T16:45:00Z',
  },
  {
    name: 'locations/66666666-6666-6666-6666-666666666666',
    uid: '66666666-6666-6666-6666-666666666666',
    displayName: 'Truist Archive GCS',
    description: 'Truist archive location for processed transactions',
    uri: 'gs://truist-archive-bucket/archive/',
    credential: 'credentials/cred-gcp-truist',
    storageType: StorageType.STORAGE_TYPE_GCS,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_DISCONNECTED,
    createTime: '2023-11-01T12:15:00Z',
    updateTime: '2024-01-20T16:45:00Z',
  },
  {
    name: 'locations/77777777-7777-7777-7777-777777777777',
    uid: '77777777-7777-7777-7777-777777777777',
    displayName: 'BBVA Catalog Source',
    description: 'BBVA catalog feed source location',
    uri: 's3://bbva-feeds-bucket/catalog/',
    credential: 'credentials/cred-aws-bbva',
    storageType: StorageType.STORAGE_TYPE_S3,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2024-02-01T10:00:00Z',
    updateTime: '2024-02-18T09:00:00Z',
  },
  {
    name: 'locations/88888888-8888-8888-8888-888888888888',
    uid: '88888888-8888-8888-8888-888888888888',
    displayName: 'BBVA Target FTP',
    description: 'BBVA target FTP server for catalog feeds',
    uri: 'ftp://bbva-ftp.example.com/feeds/',
    credential: 'credentials/cred-ftp-bbva',
    storageType: StorageType.STORAGE_TYPE_FTP,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2024-02-01T10:15:00Z',
    updateTime: '2024-02-18T09:00:00Z',
  },
  {
    name: 'locations/99999999-9999-9999-9999-999999999999',
    uid: '99999999-9999-9999-9999-999999999999',
    displayName: 'Santander Source S3',
    description: 'Santander payment files source bucket',
    uri: 's3://santander-payments-bucket/outbound/',
    credential: 'credentials/cred-aws-hsbc-prod',
    storageType: StorageType.STORAGE_TYPE_S3,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2024-01-20T08:00:00Z',
    updateTime: '2024-02-20T10:00:00Z',
  },
  {
    name: 'locations/aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa',
    uid: 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa',
    displayName: 'Santander Target SFTP',
    description: 'Santander secure file transfer endpoint',
    uri: 'sftp://santander-sftp.example.com/inbound/',
    credential: 'credentials/cred-ssh-hsbc-sftp',
    storageType: StorageType.STORAGE_TYPE_SFTP,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2024-01-20T08:15:00Z',
    updateTime: '2024-02-20T10:00:00Z',
  },
  {
    name: 'locations/bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb',
    uid: 'bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb',
    displayName: 'Wells Fargo Archive',
    description: 'Wells Fargo long-term archive storage',
    uri: 'gs://wells-fargo-archive/processed/',
    credential: 'credentials/cred-gcp-truist',
    storageType: StorageType.STORAGE_TYPE_GCS,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2023-12-01T10:00:00Z',
    updateTime: '2024-02-15T14:30:00Z',
  },
  {
    name: 'locations/cccccccc-cccc-cccc-cccc-cccccccccccc',
    uid: 'cccccccc-cccc-cccc-cccc-cccccccccccc',
    displayName: 'Citi Bank Reports',
    description: 'Citi Bank daily report delivery location',
    uri: 's3://citi-reports-bucket/daily/',
    credential: 'credentials/cred-aws-smbc-emea',
    storageType: StorageType.STORAGE_TYPE_S3,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_UNTESTED,
    createTime: '2024-01-25T09:00:00Z',
    updateTime: '2024-02-18T11:00:00Z',
  },
  {
    name: 'locations/dddddddd-dddd-dddd-dddd-dddddddddddd',
    uid: 'dddddddd-dddd-dddd-dddd-dddddddddddd',
    displayName: 'BNP Paribas Source',
    description: 'BNP Paribas transaction data source',
    uri: 's3://bnp-transactions/exports/',
    credential: 'credentials/cred-aws-bbva',
    storageType: StorageType.STORAGE_TYPE_S3,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2024-02-05T08:00:00Z',
    updateTime: '2024-02-22T09:30:00Z',
  },
  {
    name: 'locations/eeeeeeee-eeee-eeee-eeee-eeeeeeeeeeee',
    uid: 'eeeeeeee-eeee-eeee-eeee-eeeeeeeeeeee',
    displayName: 'BNP Paribas Target',
    description: 'BNP Paribas secure delivery endpoint',
    uri: 'sftp://bnp-secure.example.com/imports/',
    credential: 'credentials/cred-ssh-smbc-emea',
    storageType: StorageType.STORAGE_TYPE_SFTP,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_DISCONNECTED,
    createTime: '2024-02-05T08:15:00Z',
    updateTime: '2024-02-22T09:30:00Z',
  },
  {
    name: 'locations/ffffffff-ffff-ffff-ffff-ffffffffffff',
    uid: 'ffffffff-ffff-ffff-ffff-ffffffffffff',
    displayName: 'Deutsche Bank Azure',
    description: 'Deutsche Bank Azure Blob storage',
    uri: 'https://deutschebank.blob.core.windows.net/files/',
    credential: 'credentials/cred-aws-hsbc-prod',
    storageType: StorageType.STORAGE_TYPE_AZURE_BLOB,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2024-01-10T14:00:00Z',
    updateTime: '2024-02-19T16:00:00Z',
  },
  {
    name: 'locations/10101010-1010-1010-1010-101010101010',
    uid: '10101010-1010-1010-1010-101010101010',
    displayName: 'Credit Suisse Backup',
    description: 'Credit Suisse backup location',
    uri: 's3://credit-suisse-backup/data/',
    credential: 'credentials/cred-aws-smbc-emea',
    storageType: StorageType.STORAGE_TYPE_S3,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2023-11-15T10:00:00Z',
    updateTime: '2024-02-10T12:00:00Z',
  },
  {
    name: 'locations/20202020-2020-2020-2020-202020202020',
    uid: '20202020-2020-2020-2020-202020202020',
    displayName: 'UBS Trading Data',
    description: 'UBS trading data source location',
    uri: 'gs://ubs-trading-data/exports/',
    credential: 'credentials/cred-gcp-truist',
    storageType: StorageType.STORAGE_TYPE_GCS,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2024-01-08T11:00:00Z',
    updateTime: '2024-02-21T13:45:00Z',
  },
  {
    name: 'locations/30303030-3030-3030-3030-303030303030',
    uid: '30303030-3030-3030-3030-303030303030',
    displayName: 'JP Morgan Reports',
    description: 'JP Morgan financial reports destination',
    uri: 'sftp://jpmorgan-reports.example.com/inbound/',
    credential: 'credentials/cred-ssh-hsbc-sftp',
    storageType: StorageType.STORAGE_TYPE_SFTP,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2024-02-12T09:00:00Z',
    updateTime: '2024-02-23T10:30:00Z',
  },
  {
    name: 'locations/40404040-4040-4040-4040-404040404040',
    uid: '40404040-4040-4040-4040-404040404040',
    displayName: 'Barclays Archive',
    description: 'Barclays historical data archive',
    uri: 's3://barclays-archive/historical/',
    credential: 'credentials/cred-aws-bbva',
    storageType: StorageType.STORAGE_TYPE_S3,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_UNTESTED,
    createTime: '2023-10-20T14:00:00Z',
    updateTime: '2024-01-30T16:00:00Z',
  },
  {
    name: 'locations/50505050-5050-5050-5050-505050505050',
    uid: '50505050-5050-5050-5050-505050505050',
    displayName: 'RBC Canada Source',
    description: 'Royal Bank of Canada data source',
    uri: 's3://rbc-canada-data/outbound/',
    credential: 'credentials/cred-aws-hsbc-prod',
    storageType: StorageType.STORAGE_TYPE_S3,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2024-01-18T08:00:00Z',
    updateTime: '2024-02-24T09:00:00Z',
  },
  {
    name: 'locations/60606060-6060-6060-6060-606060606060',
    uid: '60606060-6060-6060-6060-606060606060',
    displayName: 'TD Bank Integration',
    description: 'TD Bank integration endpoint',
    uri: 'ftp://td-bank-integration.example.com/exchange/',
    credential: 'credentials/cred-ftp-bbva',
    storageType: StorageType.STORAGE_TYPE_FTP,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_CONNECTED,
    createTime: '2024-02-08T10:00:00Z',
    updateTime: '2024-02-25T11:00:00Z',
  },
  {
    name: 'locations/70707070-7070-7070-7070-707070707070',
    uid: '70707070-7070-7070-7070-707070707070',
    displayName: 'PNC Financial GCS',
    description: 'PNC Financial cloud storage',
    uri: 'gs://pnc-financial-storage/files/',
    credential: 'credentials/cred-gcp-truist',
    storageType: StorageType.STORAGE_TYPE_GCS,
    connectivityState: ConnectivityState.CONNECTIVITY_STATE_DISCONNECTED,
    createTime: '2024-01-05T12:00:00Z',
    updateTime: '2024-02-15T14:00:00Z',
  },
];
